module.exports = __webpack_public_path__ + "static/play-icon-37b68c99eddb6a3d3ba92c8f8505c427.png";